import styled from 'styled-components';

export const StyledSvgIcon = styled.span`
    width: ${(props) => `${props.width}px`};
    display: inline-block;
    vertical-align: middle;
`;

export const StyledIconBackground = styled.i`
    &:after {
      width: 100%;
      background-image: url('data:image/svg+xml;base64,${(props) => props.icon}');
      background-size: contain;
      height: 0;
      padding: 0; /* reset */
      padding-bottom: 100%;
      display: inline-block;
      background-repeat: no-repeat;
      content: '';
    }
`;
